import React from "react"
import "./dev-banner.scss"
const DevBanner = (): JSX.Element => {
    return <div className="dev-banner">DEV</div>
}

export default DevBanner
